import type { TimeCommitment } from 'bundles/adaptive-learning-common/types';

export const DEFAULT_TIME_COMMITMENT: TimeCommitment = 60;

export const TIME_COMMITMENT_OPTIONS: { minutes: number; label: string; recommended?: boolean }[] = [
  { minutes: 15, label: 'Quick session' },
  { minutes: 30, label: 'Moderate session' },
  { minutes: 45, label: 'Moderate session' },
  { minutes: 60, label: 'Recommended session', recommended: true },
];

export const AI_GENERATED_ROUTE_PREFIX = '/ai-generated/';

export const AI_GENERATED_SUMMARY_ITEM = 'AI-GENERATED-TO-BE-DONE';
export const AI_GENERATED_ONE_PAGER_ITEM = 'AI-GENERATED-ONE-PAGER';
export const AI_GENERATED_PRACTICE_ITEM = 'AI-GENERATED-PRACTICE';
